import {Component, input} from '@angular/core';

@Component({
  selector: 'navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrl: './navigation-item.component.css',
  standalone: false
})
export class NavigationItemComponent {
  route = input<string>('');
  title = input<string>('');

  isCurrentPageHref(url: string) {
    return window.location.pathname.includes(url);
  }
}
